import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { TableModule } from "primeng/table";
import { DataTableModule } from "primeng/primeng";
import { PanelModule } from "primeng/panel";

import { AutoCompleteModule } from "primeng/autocomplete";
import { FileUploadModule } from "primeng/fileupload";
import { DropdownModule } from "primeng/dropdown";
// import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { CalendarModule } from "primeng/calendar";
import { ListboxModule } from "primeng/listbox";
import { MultiSelectModule } from "primeng/multiselect";
import { GrowlModule } from "primeng/growl";
import { CheckboxModule } from "primeng/checkbox";
import { DialogModule } from "primeng/dialog";
import { TooltipModule } from "primeng/tooltip";
import { AccordionModule } from "primeng/accordion";
import { StepsModule } from "primeng/steps";
import { AppComponent } from "./app.component";
import { UserService } from "./shared/user.service";

import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { ToastrModule } from "ngx-toastr";
import { UserComponent } from "./user/user.component";
import { SignInComponent } from "./user/sign-in/sign-in.component";
import { HomeComponent } from "./home/home.component";
import { SignUpComponent } from "./user/sign-up/sign-up.component";
import { appRoutes } from "./routes";
import { AuthGuard } from "./auth/auth.guard";
import { AuthInterceptor } from "./auth/auth.interceptor";
import { Page1Component } from "./page1/page1.component";
import { MenuComponent } from "./menu/menu.component";
import { UserDetailComponent } from "./user/user-detail/user-detail.component";
import { LoadingBarHttpClientModule } from "@ngx-loading-bar/http-client";
import { LoadingBarRouterModule } from "@ngx-loading-bar/router";
import { TabViewModule } from "primeng/tabview";
import { PaginatorModule } from "primeng/paginator";
import { SelectButtonModule } from "primeng/selectbutton";
import { ErrorPageComponent } from "./error-page/error-page.component";
import { MainPageComponent } from "./main-page/main-page.component";
import { ListUserComponent } from "./user-management/list-user/list-user.component";
import { UserManagementService } from "./service/user-management.service";
import { UpdateUserComponent } from "./user-management/update-user/update-user.component";
import { CreateUserComponent } from "./user-management/create-user/create-user.component";
import { MessageComposeComponent } from "./message/message-compose/message-compose.component";
import { MessageComposeService } from "./service/message-compose.service";
import { RecipientManagementService } from "./service/recipient-management.service";
// import { RecipientManagementService } from './service/recipient-management.service';
import { MessageViewComponent } from "./message/message-view/message-view.component";
import { RecipientsListComponent } from "./recipient-management/recipients/recipients-list/recipients-list.component";
import { RecipientEditComponent } from "./recipient-management/recipients/recipient-edit/recipient-edit.component";
import { InputTextareaModule } from "primeng/inputtextarea";
import { InputTextModule } from "primeng/inputtext";
import { KeyFilterModule } from "primeng/keyfilter";
import { MessagesModule } from "primeng/messages";
import { MessageModule } from "primeng/message";
//import { EditorModule } from 'primeng/editor';
import { GroupManagementService } from "./service/group-management.service";
import { GroupListComponent } from "./group-management/group-list/group-list.component";
import { GroupEditComponent } from "./group-management/group-edit/group-edit.component";
import { GroupRecipientListComponent } from "./group-management/group-recipient-list/group-recipient-list.component";
import { SupplierManagementService } from "./service/supplier-management.service";
import { SuppliersListComponent } from "./supplier-management/suppliers/suppliers-list/suppliers-list.component";
import { SupplierEditComponent } from "./supplier-management/suppliers/supplier-edit/supplier-edit.component";
import { NewDocumentComponent } from "./document/new-document/new-document.component";
import { DocumentService } from "./service/document.service";
import { CustomerOrderListComponent } from "./order/customer-order/customer-order-list/customer-order-list.component";
import { SupplierOrderListComponent } from "./order/supplier-order/supplier-order-list/supplier-order-list.component";
import { SupplierInvoiceSendComponent } from "./invoice/supplier-invoice/supplier-invoice-send/supplier-invoice-send.component";
import { OrderService } from "./service/order.service";
import { CustomerInvoiceListComponent } from "./invoice/customer-invoice/customer-invoice-list/customer-invoice-list.component";
import { CustomerInvoiceDetailsComponent } from "./invoice/customer-invoice/customer-invoice-details/customer-invoice-details.component";
import { DetailsOfOrderForSupplierComponent } from "./order/deatils-of-order-for-supplier/details-of-order-for-supplier.component";
import { DetailsOfOrderForCustomerComponent } from "./order/deatils-of-order-for-customer/details-of-order-for-customer.component";
import { InvoiceFilePreviewComponent } from "./invoice/invoice-file-preview/invoice-file-preview.component";
import { InvoiceService } from "./service/invoice.service";
import { SupplierInvoiceListComponent } from "./invoice/supplier-invoice/supplier-invoice-list/supplier-invoice-list.component";
import { SupplierInvoiceDetailsComponent } from "./invoice/supplier-invoice/supplier-invoice-details/supplier-invoice-details.component";
import { ReportCustomerInvoiceComponent } from "./report/report-customer-invoice/report-customer-invoice.component";
import { ReportService } from "./service/report.service";
import { LPInvoiceDetailsComponent } from "./lp/lp-invoice-details/lp-invoice-details.component";
import { DatePipe } from "@angular/common";
import { ReportBudgetUtilizationComponent } from "./report/report-budget-utilization/report-budget-utilization.component";
import { NewDocumentProfitComponent } from "./document/new-document-profit/new-document-profit.component";
import { DocumentFilePreviewComponent } from "./document/document-file-preview/document-file-preview.component";
import { NewOrderComponent } from "./new-order/new-order.component";
import { UpdateOrderComponent } from "./update-order/update-order.component";
import { AddItemComponent } from "./add-item/add-item.component";
import { ItemService } from "./service/item.service";
import { UpdateItemComponent } from "./update-item/update-item.component";
import { EquipmentSignComponent } from "./equipment-sign/equipment-sign.component";

import { ClientService } from "./service/client.service";
import { AddClientComponent } from "./add-client/add-client.component";
import { EditClientComponent } from "./edit-client/edit-client.component";
import { ClientDetailsComponent } from "./client-details/client-details.component";
import { CallRequestDetailsComponent } from "./call-request-details/call-request-details.component";
import { CallsReportComponent } from './calls-report/calls-report.component';
import { EditCallTypeComponent } from './edit-call-type/edit-call-type.component';

@NgModule({
  declarations: [
    AppComponent,
    SignUpComponent,
    UserComponent,
    SignInComponent,
    HomeComponent,
    Page1Component,
    MenuComponent,
    UserDetailComponent,
    ErrorPageComponent,
    MainPageComponent,
    ListUserComponent,
    UpdateUserComponent,
    CreateUserComponent,
    MessageComposeComponent,
    MessageViewComponent,
    RecipientsListComponent,
    RecipientEditComponent,
    GroupListComponent,
    GroupEditComponent,
    GroupRecipientListComponent,
    SuppliersListComponent,
    SupplierEditComponent,
    NewDocumentComponent,
    CustomerOrderListComponent,
    SupplierOrderListComponent,
    SupplierInvoiceSendComponent,
    CustomerInvoiceListComponent,
    CustomerInvoiceDetailsComponent,
    DetailsOfOrderForSupplierComponent,
    DetailsOfOrderForCustomerComponent,
    InvoiceFilePreviewComponent,
    SupplierInvoiceListComponent,
    SupplierInvoiceDetailsComponent,
    ReportCustomerInvoiceComponent,
    ReportBudgetUtilizationComponent,
    LPInvoiceDetailsComponent,
    NewDocumentProfitComponent,
    DocumentFilePreviewComponent,
    NewOrderComponent,
    UpdateOrderComponent,
    AddItemComponent,
    UpdateItemComponent,
    EquipmentSignComponent,
    AddClientComponent,
    EditClientComponent,
    ClientDetailsComponent,
    CallRequestDetailsComponent,
    CallsReportComponent,
    EditCallTypeComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes),
    TableModule,
    PanelModule,
    AutoCompleteModule,
    FileUploadModule,
    DropdownModule,
    CalendarModule,
    ListboxModule,
    MultiSelectModule,
    GrowlModule,
    CheckboxModule,
    DialogModule,
    LoadingBarHttpClientModule,
    LoadingBarRouterModule,
    TooltipModule,
    AccordionModule,
    DataTableModule,
    TabViewModule,
    PaginatorModule,
    StepsModule,
    SelectButtonModule,
    InputTextareaModule,
    InputTextModule,
    KeyFilterModule,
    MessagesModule,
    MessageModule,
    //EditorModule
  ],
  providers: [
    UserService,
    UserManagementService,
    MessageComposeService,
    RecipientManagementService,
    GroupManagementService,
    AuthGuard,
    SupplierManagementService,
    OrderService,
    InvoiceService,
    DocumentService,
    ReportService,
    DatePipe,
    ItemService,
    ClientService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/app.module.ts